import Vue from "vue";
import Vuex from "vuex";
import { Api } from "../api";

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    api: new Api(),
    user: null,
    pricing: {
      setup: { price_per: "once", net: 30, gross: 35.7 },
      image: { price_per: "gb/month", net: 0.1, gross: 0.119 },
      tiers: {
        C100: { price_per: "hour", net: 0.1, gross: 0.119 },
        C200: { price_per: "hour", net: 0.2, gross: 0.238 },
        C400: { price_per: "hour", net: 0.4, gross: 0.476 },
        C100P: { price_per: "month", net: 20, gross: 23.8 },
        C200P: { price_per: "month", net: 40, gross: 47.6 },
        C400P: { price_per: "month", net: 80, gross: 95.2 }
      }
    }
  },
  mutations: {
    user(state, user) {
      if (state.user) user = Object.assign(state.user, user);
      state.user = user;
    },
    pricing(state, pricing) {
      if (state.pricing) pricing = Object.assign(state.pricing, pricing);
      state.pricing = pricing;
    }
  },
  actions: {},
  modules: {}
});

export default store;
